import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import type { SiteArea } from '../../services/sitesApi';

type Props = {
  open: boolean;
  title: string;
  areaId: string;
  mountLabel: string;
  areas: SiteArea[];
  error: string | null;
  saving: boolean;
  canWrite: boolean;
  onClose: () => void;
  onAreaChange: (areaId: string) => void;
  onMountChange: (mount: string) => void;
  onSave: () => void;
};

/** Edit/Set camera area + mount dialog (Epic 281-B). */
export const CameraLocationDialog: React.FC<Props> = ({
  open,
  title,
  areaId,
  mountLabel,
  areas,
  error,
  saving,
  canWrite,
  onClose,
  onAreaChange,
  onMountChange,
  onSave,
}) => (
  <Dialog open={open} onClose={() => !saving && onClose()} maxWidth="sm" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
      )}
      <FormControl fullWidth margin="normal" required>
        <InputLabel>Area</InputLabel>
        <Select
          value={areaId}
          label="Area"
          onChange={(e) => onAreaChange(String(e.target.value))}
        >
          <MenuItem value="">Select area…</MenuItem>
          {areas
            .filter((area) => area.active !== false)
            .map((area) => (
              <MenuItem key={area.area_id} value={area.area_id}>
                {area.display_name || area.area_id}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <TextField
        fullWidth
        margin="normal"
        label="Mount label"
        value={mountLabel}
        onChange={(e) => onMountChange(e.target.value)}
        placeholder="e.g., Dock 4 aisle"
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={saving}>Cancel</Button>
      <Button
        variant="contained"
        onClick={onSave}
        disabled={!canWrite || saving || !areaId}
      >
        {saving ? 'Saving…' : 'Save'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CameraLocationDialog;
